export const styles = (theme) => {
  return {
    down_icon: {
      position: "absolute",
      pointerEvents: "none",
      top: "calc(32% - px)",
      right: 10,
      width: 20,
      height: 20,
      fontWeight: "bold",
      [theme.breakpoints.down(641)]: {
        top: "calc(32% - 3px)",
        right: 10,
        width: 20,
        height: 20,
      },
      [theme.breakpoints.down(481)]: {
        top: "calc(30% - 2px)",
        right: 10,
        width: 20,
        height: 20,
      },
      [theme.breakpoints.down(421)]: {
        top: "calc(30% - 2px)",
        right: 10,
        width: 20,
        height: 20,
      },
      [theme.breakpoints.down(321)]: {
        top: "calc(30% - 2px)",
        right: 10,
        width: 20,
        height: 20,
      },
      [theme.breakpoints.up(750)]: {
        top: "calc(30% - 2px)",
        right: 10,
        width: 20,
        height: 20,
      },
    },
    formControl: {
      "& .MuiInputBase-input:focus": {
        backgroundColor: "unset",
      },
    },
    menuItem: {
      fontSize: "18px",
      [theme.breakpoints.down("641")]: {
        fontSize: "16px",
      },
      [theme.breakpoints.down("481")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("421")]: {
        fontSize: "13.5px",
      },
      [theme.breakpoints.down("401")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("381")]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down("361")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("321")]: {
        fontSize: "10px",
      },
    },
    goldGradientBox: {
      position: "relative",
      padding: "3px",
      marginBottom: "10px",
      background: "radial-gradient(45.17% 249.6% at 50% 0%, #FCD970 0%, #FCD970 50%, #A77E02 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
      boxShadow: "0px 4px 4px #c3c3c3",
      "& > root": {
        borderRadius: "12px",
        backgroundColor: "#fff",
        padding: "16px",
        width: "100%",
        height: "100%",
      },
    },
  };
};
